import { render, staticRenderFns } from "./chemEtc.vue?vue&type=template&id=157c8c24"
import script from "./chemEtc.vue?vue&type=script&lang=js"
export * from "./chemEtc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('157c8c24')) {
      api.createRecord('157c8c24', component.options)
    } else {
      api.reload('157c8c24', component.options)
    }
    module.hot.accept("./chemEtc.vue?vue&type=template&id=157c8c24", function () {
      api.rerender('157c8c24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/chemEtc.vue"
export default component.exports